<template>
    <div>
        <loading :dspin="loadingInfo"></loading>
        <div v-if="!loadingInfo" class="w3-animate-opacity patient-personal-details w3-container"
             :class="!propsPatientId ? 'w3-right' : ''">
            <img src="/face.png" class="w3-center">
            <table class="w3-table w3-white font-size-1em  w3-animate-opacity">
                <tr>
                    <td class="font-weight-bold flow-padding">{{$t("dob")}}</td>
                    <td class="flow-padding">{{ dob }}</td>
                </tr>
                <tr>
                    <td class="flow-padding font-weight-bold">{{$t("gender")}}</td>
                    <td class="flow-padding">{{ sex }}</td>
                </tr>
                <tr>
                    <td class="flow-padding font-weight-bold">{{$t("phone")}}</td>
                    <td class="flow-padding">{{ phone }}</td>
                </tr>
                <tr>
                    <td class="flow-padding font-weight-bold">{{$t("language")}}</td>
                    <td class="flow-padding">{{ language }}</td>
                </tr>
                <tr>
                    <td class="flow-padding font-weight-bold">{{$t("address")}}</td>
                    <td class="flow-padding">{{ address }}</td>
                </tr>
                <tr>
                    <td class="flow-padding font-weight-bold">{{$t("houseDoctor")}}</td>
                    <td class="flow-padding">{{ houseDoctor }}</td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Loading from "../common/Loading";

    const frc = Vue.prototype.$frc;

    export default {
        name: "PatientPersonalData",
        components: {Loading},
        props: ['propsPatientId'],
        data() {
            return {
                patientId: undefined,
                info: {},
                notGiven: this.$t("notGiven"),
                loadingInfo: true
            }
        },
        mounted() {
            if (!this.propsPatientId) {
                this.patientId = this.$route.params.id;
            } else {
                this.patientId = this.propsPatientId;
            }

            this.getPatientPersonalInfo();
        },
        computed: {
            dob() {
                var res = this.info.dob;

                return res ? res : this.notGiven;
            },
            address() {
                var address = [];
                if (this.info.street_address) address.push(this.info.street_address);
                if (this.info.state_or_province) address.push(this.info.state_or_province);
                if (this.info.city) address.push(this.info.city);
                if (this.info.zipCode) address.push(this.info.zipCode);
                if (this.info.country) address.push(this.info.country);

                return address.length > 0 ? address.join(", ") : this.notGiven;
            },
            sex() {
                if (!this.info.sex) {
                    return this.notGiven;
                }
                var sex = this.info.sex;
                if (sex.match(/m|male/i)) {
                    return this.$t("male");
                }
                if (sex.match(/f|v|female/i)) {
                    return this.$t("female");
                }

                return this.$t("other") + " (" + sex + ")";
            },
            phone() {
                var p1 = this.info.home_phone_number;
                var p2 = this.info.business_phone_number;

                if (!p1 && !p2) {
                    return this.notGiven;
                }

                return p1 ? p1 : p2;
            },
            language() {
                return this.info.language ? this.info.language : this.notGiven;
            },
            houseDoctor() {
                return this.notGiven;
            }
        },
        watch: {
            propsPatientId(newVal, oldVal) {
                this.patientId = newVal;
                this.getPatientPersonalInfo();
            }
        },
        methods: {
            getPatientPersonalInfo() {
                var app = this;
                this.info = {};
                this.loadingInfo = true;
                frc.getPatient(this.patientId).then(function (res) {
                    app.info.dob = res.data.dob;
                    var entry = res.data.properties.entry;
                    entry.forEach(function (e) {
                        app.info[e.key] = e.value;
                    });
                    app.loadingInfo = false;
                }).catch(function (ex) {
                    app.loadingInfo = false;
                });
            },
        }
    }
</script>